import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jcn5s8r6ur: FaireBrandEntity = {
  token: "b_jcn5s8r6ur",
  type: "brand",
  name: "Adorro",
  avatarUrl:
    "https://cdn.faire.com/fastly/22ee051cec0753a0be4e84c2bac69f8a3e706ceac62dac18caec4940cf7ed71c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8b2bbe72fe2167a2e7db288a38d05a960b75cdec05a429b526e14706d7a56c85.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/22ee051cec0753a0be4e84c2bac69f8a3e706ceac62dac18caec4940cf7ed71c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8b2bbe72fe2167a2e7db288a38d05a960b75cdec05a429b526e14706d7a56c85.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 258,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Adorro! Adorro is an eco-friendly accessories brand created to make fashionable yet functional accessories. Our collection offers claw clips for all hair types, textures, and lengths. Our designs are inspired by timeless classics with a fun twist. You'll recognize our classic silhouettes with unique prints and patterns for every season and major holidays. We also specialize in our specialty claws that feature cute and fun novelty items. Our products are made with you in mind so that you can confidently wear Adorro. :) Designed in Chicago, IL and responsibly made in Yiwu, China.\n\nSustainability: We prioritize the use of sustainable, eco-friendly materials to craft our hair clips. Our eco-friendly clips are made with cellulose, a synthetic fiber produced from plant derivatives such as wood pulp and cotton. Cellulose is both durable and biodegradable.\nPackaging: We eliminated individual wrapped plastics and will only use a singular plastic bag to protect our product in their packs. Any packing material that is plastic is reused or repurposed as packing material instead of thrown away.\nShipping: We will do our best to ship your orders together when possible to reduce shipping material waste and our carbon footprint, saving you money too!",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:49.700Z",
    importedBy: "entity-db-cli",
  },
};
